import React, { useCallback, useState, useRef } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import StockForm from '@galo-monitor/web-containers/forms/farm/StockForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const StockModal = (props) => {
  const {
    id,
    open,
    handleClose,
    onSuccess,
    stock
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    () => {
      setLoading(false)
      createDialog({
        id: 'error-stock',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'male',
            action: toLower(t(isEmpty(stock) ? 'register' : 'update')),
            this: toLower(t('stock', { howMany: 1 }))
          })  }.`
        }
      })
    },
    [createDialog, stock, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('register of {this}', {
        this: t('stock', { howMany: 1 })
      }) }
      maxWidth="xs"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="import"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <StockForm
        ref={ formRef }
        stock={ stock }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

StockModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  stock: PropTypes.object
}

StockModal.defaultProps = {
  stock: {}
}

export default StockModal
